import { ItemEditController } from "./item-edit.controller";
import { ItemEdit } from "./item-edit.service";

angular
    .module("thor.item-edit", [])
    .service("itemEdit", ItemEdit)
    .component("itemEdit", {
        bindings: {
            getTranslationStatus: "&",
            isSaving: "=",
            selectedTargetLanguage: "<",
            sourceLang: "<"
        },
        controller: ItemEditController,
        controllerAs: "itemEditCtrl",
        template: require("./item-edit.html")
    });
